/**
 *   This file is auto-generated.
 *   Any manual changes done could be lost.
 **/

/** All built-in and custom scalars, mapped to their actual values */

/**
 * An Applied Directive is an instances of a directive as applied to a schema
 * element. This type is NOT specified by the graphql specification presently.
 */

/**
 * Directive arguments can have names and values.  The values are in graphql SDL
 * syntax printed as a string. This type is NOT specified by the graphql
 * specification presently.
 */
export const AccountStatusValues = Object.freeze({
  /** The account is an active account */
  Active: 'active',

  /** The account is no longer an active account */
  Inactive: 'inactive',

  /** The account has been closed */
  Closed: 'closed'
});
/**
 * "
 * The lifecycle status of the account
 */

export const ActivitiesContainerTypeValues = Object.freeze({
  Site: 'SITE',
  Project: 'PROJECT',
  Space: 'SPACE'
});
export const ActivitiesFilterTypeValues = Object.freeze({
  And: 'AND',
  Or: 'OR'
});
export const ActivitiesObjectTypeValues = Object.freeze({
  Issue: 'ISSUE',
  Page: 'PAGE',
  Blogpost: 'BLOGPOST'
});
export const ActivityEventTypeValues = Object.freeze({
  Assigned: 'ASSIGNED',
  Unassigned: 'UNASSIGNED',
  Viewed: 'VIEWED',
  Commented: 'COMMENTED',
  Updated: 'UPDATED',
  Created: 'CREATED',
  Liked: 'LIKED',
  Transitioned: 'TRANSITIONED',
  Published: 'PUBLISHED',
  Edited: 'EDITED'
});
export const ActivityObjectTypeValues = Object.freeze({
  Site: 'SITE',
  Project: 'PROJECT',
  Issue: 'ISSUE',
  Comment: 'COMMENT',
  Space: 'SPACE',
  Page: 'PAGE',
  Blogpost: 'BLOGPOST',
  Task: 'TASK'
});
export const ActivityProductValues = Object.freeze({
  Jira: 'JIRA',
  JiraBusiness: 'JIRA_BUSINESS',
  JiraSoftware: 'JIRA_SOFTWARE',
  JiraOps: 'JIRA_OPS',
  JiraServiceDesk: 'JIRA_SERVICE_DESK',
  Confluence: 'CONFLUENCE'
});
export const ApiContextValues = Object.freeze({
  Devops: 'DEVOPS'
});
/** Only used for inside the schema to mark the context for generic types */

export const ApiGroupValues = Object.freeze({
  Compass: 'COMPASS',
  Jira: 'JIRA',
  Forge: 'FORGE',
  Polaris: 'POLARIS',
  Caas: 'CAAS',
  XenLogsApi: 'XEN_LOGS_API',
  DevopsService: 'DEVOPS_SERVICE',
  DevopsContainerRelationship: 'DEVOPS_CONTAINER_RELATIONSHIP'
});
/**
 * This enum is the names of API groupings within the total Atlassian API.
 *
 * This is used by our documentation tooling to group together types and fields into logical groups
 */

export const AppDeploymentEventLogLevelValues = Object.freeze({
  Info: 'INFO',
  Warning: 'WARNING',
  Error: 'ERROR'
});
export const AppDeploymentStatusValues = Object.freeze({
  InProgress: 'IN_PROGRESS',
  Done: 'DONE',
  Failed: 'FAILED'
});
export const AppDeploymentStepStatusValues = Object.freeze({
  Started: 'STARTED',
  Done: 'DONE',
  Failed: 'FAILED'
});
export const AppEnvironmentTypeValues = Object.freeze({
  Development: 'DEVELOPMENT',
  Staging: 'STAGING',
  Production: 'PRODUCTION'
});
export const AppNetworkPermissionTypeValues = Object.freeze({
  Navigation: 'NAVIGATION',
  Images: 'IMAGES',
  Media: 'MEDIA',
  Scripts: 'SCRIPTS',
  Styles: 'STYLES',
  FetchBackendSide: 'FETCH_BACKEND_SIDE',
  FetchClientSide: 'FETCH_CLIENT_SIDE'
});
export const AppNetworkPermissionTypeExtensionValues = Object.freeze({
  Navigation: 'NAVIGATION',
  Images: 'IMAGES',
  Media: 'MEDIA',
  Scripts: 'SCRIPTS',
  Styles: 'STYLES',
  FetchBackendSide: 'FETCH_BACKEND_SIDE',
  FetchClientSide: 'FETCH_CLIENT_SIDE'
});
export const AppSecurityPoliciesPermissionTypeValues = Object.freeze({
  Scripts: 'SCRIPTS',
  Styles: 'STYLES'
});
export const AppSecurityPoliciesPermissionTypeExtensionValues = Object.freeze({
  Scripts: 'SCRIPTS',
  Styles: 'STYLES'
});
export const AppStoredEntityConditionValues = Object.freeze({
  StartsWith: 'STARTS_WITH'
});
export const AppTaskStateValues = Object.freeze({
  Pending: 'PENDING',
  Running: 'RUNNING',
  Complete: 'COMPLETE',
  Failed: 'FAILED'
});
export const AtlassianProductHostingTypeValues = Object.freeze({
  Cloud: 'CLOUD',
  Server: 'SERVER',
  DataCenter: 'DATA_CENTER'
});
/** Hosting type where Atlassian product instance is installed. */

export const BoardFeatureStatusValues = Object.freeze({
  Enabled: 'ENABLED',
  Disabled: 'DISABLED',
  ComingSoon: 'COMING_SOON'
});
export const BoardFeatureToggleStatusValues = Object.freeze({
  Enabled: 'ENABLED',
  Disabled: 'DISABLED'
});
export const BuiltinPolarisIdeaFieldValues = Object.freeze({
  Key: 'KEY',
  Summary: 'SUMMARY',
  Description: 'DESCRIPTION',
  Implementations: 'IMPLEMENTATIONS',
  Supports: 'SUPPORTS'
});
export const CompassComponentTypeValues = Object.freeze({
  /** A standalone piece of software that is directly consumable by an end-user. */
  Application: 'APPLICATION',

  /** A standalone piece of software that provides some functionality for other software via embedding. */
  Library: 'LIBRARY',

  /** A standalone piece of software that provides some functionality for other software over the network. */
  Service: 'SERVICE',

  /** Software that does not fit into the pre-defined categories */
  Other: 'OTHER'
});
/** Identifies the type of a component */

export const CompassFieldTypeValues = Object.freeze({
  Text: 'TEXT',
  Number: 'NUMBER',
  Date: 'DATE',
  Enum: 'ENUM'
});
/** Specifies the type of value for a field. */

export const CompassLinkTypeValues = Object.freeze({
  /** Documentation for the component */
  Document: 'DOCUMENT',

  /** Communication Channels for contacting the owners/support of the component */
  CommsChannel: 'COMMS_CHANNEL',

  /** Source Code Repository for the component */
  Repository: 'REPOSITORY',

  /** Jira/3rdParty Project link for the component */
  Project: 'PROJECT',

  /** Dashboard Link for the component */
  Dashboard: 'DASHBOARD',

  /** On Call schedule link for a Component */
  OnCall: 'ON_CALL',

  /** Other link for a Component */
  OtherLink: 'OTHER_LINK'
});
/** Types used to identify the intent of the link */

export const CompassQuerySortOrderValues = Object.freeze({
  Asc: 'ASC',
  Desc: 'DESC'
});
export const CompassRelationshipTypeValues = Object.freeze({
  DependsOn: 'DEPENDS_ON'
});
/** Relationships must be one of the following types. */

export const CompassScorecardImportanceValues = Object.freeze({
  /** Automatically applied to all Components of the specified type(s) and cannot be removed */
  Required: 'REQUIRED',

  /** Suggested to component owners when selecting scorecards to apply to their component */
  Recommended: 'RECOMMENDED',

  /** Scorecards primarily focused on specific use cases within teams or departments */
  UserDefined: 'USER_DEFINED'
});
export const DeploymentStateValues = Object.freeze({
  Pending: 'PENDING',
  InProgress: 'IN_PROGRESS',
  Successful: 'SUCCESSFUL',
  Cancelled: 'CANCELLED',
  Failed: 'FAILED',
  RolledBack: 'ROLLED_BACK',
  Unknown: 'UNKNOWN'
});
/** The state that a code deployment can be in (think of a deployment in Bitbucket Pipelines, CircleCI, etc). */

export const DevOpsEnvironmentCategoryValues = Object.freeze({
  Production: 'PRODUCTION',
  Staging: 'STAGING',
  Testing: 'TESTING',
  Development: 'DEVELOPMENT',
  Unmapped: 'UNMAPPED'
});
/**
 * The types of environments that a code change can be released to.
 *
 * The release may be via a code deployment or via a feature flag change.
 */

export const DevOpsJiraProjectTypeValues = Object.freeze({
  JiraSoftware: 'JIRA_SOFTWARE',
  JiraServicedesk: 'JIRA_SERVICEDESK',
  JiraCore: 'JIRA_CORE'
});
export const DevOpsMetricsCycleTimePhaseValues = Object.freeze({
  /** Development phase from initial code commit to opened pull request. */
  CommitToPr: 'COMMIT_TO_PR',

  /** Development phase from initial code commit to deployed code. */
  CommitToDeployment: 'COMMIT_TO_DEPLOYMENT'
});
export const DevOpsMetricsResolutionUnitValues = Object.freeze({
  Hour: 'HOUR',
  Day: 'DAY',
  Week: 'WEEK'
});
/** Unit for specified resolution value. */

export const DevOpsRelationshipCertaintyValues = Object.freeze({
  /** The relationship was created by a user. */
  Explicit: 'EXPLICIT',

  /** The relationship was inferred by a system. */
  Implicit: 'IMPLICIT'
});
export const DevOpsRelationshipCertaintyFilterValues = Object.freeze({
  /** Return only relationships created by a user. */
  Explicit: 'EXPLICIT',

  /** Return only relationships inferred by a system. */
  Implicit: 'IMPLICIT',

  /** Return all relationships. */
  All: 'ALL'
});
export const DevOpsRepositoryHostingProviderFilterValues = Object.freeze({
  BitbucketCloud: 'BITBUCKET_CLOUD',
  ThirdParty: 'THIRD_PARTY',
  All: 'ALL'
});
export const DevOpsServiceAndJiraProjectRelationshipTypeValues = Object.freeze({
  /** A standard relationship */
  Default: 'DEFAULT',

  /** A relationship created for the change management feature */
  ChangeManagement: 'CHANGE_MANAGEMENT'
});
export const DevOpsServiceAndRepositoryRelationshipSortByValues = Object.freeze({
  LastInferredAt: 'LAST_INFERRED_AT'
});
export const DevOpsServiceRelationshipTypeValues = Object.freeze({
  DependsOn: 'DEPENDS_ON',
  Contains: 'CONTAINS'
});
/** #################### Enums ##################### */

export const DevStatusActivityValues = Object.freeze({
  PrOpen: 'PR_OPEN',
  PrMerged: 'PR_MERGED',
  PrDeclined: 'PR_DECLINED',
  BranchOpen: 'BRANCH_OPEN',
  Commit: 'COMMIT'
});
export const EpicViewValues = Object.freeze({
  /** All epics regardless of status */
  All: 'ALL',

  /** Epics with status complete */
  Completed: 'COMPLETED',

  /** Epics with status incomplete */
  Incomplete: 'INCOMPLETE'
});
/** View settings for epics on the roadmap */

export const FunctionTriggerTypeValues = Object.freeze({
  Frontend: 'FRONTEND',
  Manual: 'MANUAL',
  Product: 'PRODUCT',
  Web: 'WEB'
});
/** Which type of trigger */

export const GrantCheckProductValues = Object.freeze({
  Jira: 'JIRA',
  JiraServicedesk: 'JIRA_SERVICEDESK',
  Confluence: 'CONFLUENCE'
});
export const IssueDevOpsCommitChangeTypeValues = Object.freeze({
  Added: 'ADDED',
  Deleted: 'DELETED',
  Copied: 'COPIED',
  Moved: 'MOVED',
  Modify: 'MODIFY',
  Unknown: 'UNKNOWN'
});
export const IssueDevOpsDeploymentEnvironmentTypeValues = Object.freeze({
  Production: 'PRODUCTION',
  Staging: 'STAGING',
  Testing: 'TESTING',
  Development: 'DEVELOPMENT',
  Unmapped: 'UNMAPPED'
});
export const IssueDevOpsDeploymentStateValues = Object.freeze({
  Pending: 'PENDING',
  InProgress: 'IN_PROGRESS',
  Successful: 'SUCCESSFUL',
  Cancelled: 'CANCELLED',
  Failed: 'FAILED',
  RolledBack: 'ROLLED_BACK',
  Unknown: 'UNKNOWN'
});
export const IssueDevOpsPullRequestStatusValues = Object.freeze({
  Open: 'OPEN',
  Merged: 'MERGED',
  Declined: 'DECLINED'
});
export const JiraProjectAndRepositoryRelationshipSortByValues = Object.freeze({
  LastInferredAt: 'LAST_INFERRED_AT'
});
/** #################### Enums ##################### */

export const JiraProjectSortFieldValues = Object.freeze({
  /** sorts by project name */
  Name: 'NAME',

  /** sorts by project key */
  Key: 'KEY',

  /** sorts by lead */
  Lead: 'LEAD',

  /** sorts by category */
  Category: 'CATEGORY'
});
export const JiraProjectTypeValues = Object.freeze({
  /** A service desk project */
  ServiceDesk: 'SERVICE_DESK',

  /** A business project */
  Business: 'BUSINESS',

  /** A software project */
  Software: 'SOFTWARE'
});
/** Jira Project types */

export const JiraReleasesEpicReleaseStatusFilterValues = Object.freeze({
  /** Only epics that have been released (to any environment) will be included in the results. */
  Released: 'RELEASED',

  /**
   * Epics that have been released will be returned first, followed by epics that haven't
   * yet been released.
   */
  ReleasedAndUnreleased: 'RELEASED_AND_UNRELEASED'
});
/**
 * Used for specifying whether or not epics that haven't been released should be included
 * in the results.
 *
 * For an epic to be considered as released, at least one of the issues or subtasks within
 * it must have been released.
 */

export const JiraReleasesIssueReleaseStatusFilterValues = Object.freeze({
  /** Only issues that have been released (to any environment) will be included in the results. */
  Released: 'RELEASED',

  /** Only issues that have *not* been released (to any environment) will be included in the results. */
  Unreleased: 'UNRELEASED',

  /**
   * Issues that have been released will be returned first, followed by issues that haven't
   * yet been released.
   */
  ReleasedAndUnreleased: 'RELEASED_AND_UNRELEASED'
});
/**
 * Used for specifying whether or not issues that haven't been released should be included
 * in the results.
 */

export const LicenseOverrideStateValues = Object.freeze({
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  Trial: 'TRIAL'
});
export const MarketplaceAppPaymentModelValues = Object.freeze({
  Free: 'FREE',
  PaidViaPartner: 'PAID_VIA_PARTNER',
  PaidViaAtlassian: 'PAID_VIA_ATLASSIAN'
});
/** Payment model for integrating an app with an Atlassian product. */

export const MarketplaceAppPermissionValues = Object.freeze({
  ManageAppDetails: 'MANAGE_APP_DETAILS'
});
/** Permissions that a MarketplaceUser can have on MarketplaceApps */

export const MarketplaceAppVersionVisibilityValues = Object.freeze({
  Private: 'PRIVATE',
  Public: 'PUBLIC'
});
/** Visibility of the Marketplace app's version */

export const MarketplaceBillingCycleValues = Object.freeze({
  Annual: 'ANNUAL',
  Monthly: 'MONTHLY'
});
/** Billing cycle for which pricing plan applies */

export const MarketplaceCloudFortifiedStatusValues = Object.freeze({
  Approved: 'APPROVED',
  Rejected: 'REJECTED',
  NotAParticipant: 'NOT_A_PARTICIPANT'
});
export const MarketplaceListingStatusValues = Object.freeze({
  Private: 'PRIVATE',
  Public: 'PUBLIC',
  Submitted: 'SUBMITTED',
  ReadyToLaunch: 'READY_TO_LAUNCH',
  Rejected: 'REJECTED'
});
/** Status of app’s listing in Marketplace. */

export const MarketplaceLocationValues = Object.freeze({
  Website: 'WEBSITE',
  InProduct: 'IN_PRODUCT'
});
/** Marketplace location */

export const MarketplacePartnerSupportHolidayFrequencyValues = Object.freeze({
  OneTime: 'ONE_TIME',
  Annual: 'ANNUAL'
});
/** Tells whether support is on holiday only one time or if it repeats annually. */

export const MarketplacePartnerTypeValues = Object.freeze({
  AtlassianInternal: 'ATLASSIAN_INTERNAL'
});
/** Tells if the Marketplace partner is an Atlassian’s internal one. */

export const MarketplacePricingPlanStatusValues = Object.freeze({
  Live: 'LIVE',
  Pending: 'PENDING',
  Draft: 'DRAFT'
});
/** Status of the plan : LIVE, PENDING or DRAFT */

export const MarketplacePricingTierModeValues = Object.freeze({
  Graduated: 'GRADUATED',
  Volume: 'VOLUME'
});
/** Mode of the tier : GRADUATED (progressive PUP), VOLUME (constant for all users) */

export const MarketplacePricingTierPolicyValues = Object.freeze({
  Block: 'BLOCK',
  PerUnit: 'PER_UNIT'
});
/** Policy of the tier : BLOCK (FLAT) or PER_UNIT (PUP) */

export const MarketplacePricingTierTypeValues = Object.freeze({
  UserTiered: 'USER_TIERED',
  RemoteAgentTiered: 'REMOTE_AGENT_TIERED'
});
/** Type of the tier */

export const PolarisCommentKindValues = Object.freeze({
  View: 'VIEW'
});
export const PolarisFieldTypeValues = Object.freeze({
  PolarisIdeaStringField: 'PolarisIdeaStringField',
  PolarisIdeaDateTimeField: 'PolarisIdeaDateTimeField',
  PolarisIdeaDateField: 'PolarisIdeaDateField',
  PolarisIdeaUserField: 'PolarisIdeaUserField',
  PolarisIdeaUsersField: 'PolarisIdeaUsersField',
  PolarisIdeaOptionField: 'PolarisIdeaOptionField',
  PolarisIdeaOptionsField: 'PolarisIdeaOptionsField',
  PolarisIdeaLabelsField: 'PolarisIdeaLabelsField',
  PolarisIdeaNumberField: 'PolarisIdeaNumberField'
});
/** ##### Input ####### */

export const PolarisRefreshErrorValues = Object.freeze({
  NeedAuth: 'NEED_AUTH',
  InvalidSnippet: 'INVALID_SNIPPET',
  NotFound: 'NOT_FOUND',
  InternalError: 'INTERNAL_ERROR'
});
export const PolarisResolvedObjectAuthTypeValues = Object.freeze({
  Oauth2: 'OAUTH2',
  ApiKey: 'API_KEY'
});
export const PolarisSnippetPropertyKindValues = Object.freeze({
  Number: 'NUMBER',

  /**  generic number */
  Rating: 'RATING',

  /**  1-5 integer rating */
  Labels: 'LABELS'
});
export const PolarisSortOrderValues = Object.freeze({
  Asc: 'ASC',
  Desc: 'DESC'
});
export const PolarisValueOperatorValues = Object.freeze({
  Gt: 'GT',
  Lt: 'LT',
  Gte: 'GTE',
  Lte: 'LTE',
  Eq: 'EQ'
});
export const PolarisViewFilterKindValues = Object.freeze({
  FieldIdentity: 'FIELD_IDENTITY',

  /**  a field being matched by identity */
  FieldNumeric: 'FIELD_NUMERIC',

  /**  a field being matched by numeric comparison */
  Text: 'TEXT'
});
export const PolarisViewFilterOperatorValues = Object.freeze({
  Lt: 'LT',
  Lte: 'LTE',
  Gt: 'GT',
  Gte: 'GTE',
  Eq: 'EQ',
  Neq: 'NEQ'
});
export const PolarisViewSetTypeValues = Object.freeze({
  Capture: 'CAPTURE',
  Prioritize: 'PRIORITIZE',
  Deliver: 'DELIVER',
  System: 'SYSTEM',
  Custom: 'CUSTOM',
  Single: 'SINGLE',

  /**  for views that are used to manage the display of single ideas (e.g., Idea views) */
  Section: 'SECTION'
});
export const PolarisVisualizationTypeValues = Object.freeze({
  Table: 'TABLE',
  Board: 'BOARD',
  Twoxtwo: 'TWOXTWO'
});
export const ProductValues = Object.freeze({
  Jira: 'Jira',
  Confluence: 'Confluence'
});
export const RateLimitingCurrencyValues = Object.freeze({
  TestingService: 'TESTING_SERVICE'
});
export const RoadmapPaletteColorValues = Object.freeze({
  Purple: 'PURPLE',
  Blue: 'BLUE',
  Green: 'GREEN',
  Teal: 'TEAL',
  Yellow: 'YELLOW',
  Orange: 'ORANGE',
  Grey: 'GREY',
  DarkPurple: 'DARK_PURPLE',
  DarkBlue: 'DARK_BLUE',
  DarkGreen: 'DARK_GREEN',
  DarkTeal: 'DARK_TEAL',
  DarkYellow: 'DARK_YELLOW',
  DarkOrange: 'DARK_ORANGE',
  DarkGrey: 'DARK_GREY'
});
/** Supported colors in the Palette */

export const RoadmapSprintStateValues = Object.freeze({
  /** A sprint that was completed in the past */
  Closed: 'CLOSED',

  /** A current sprint */
  Active: 'ACTIVE',

  /** A sprint that is planned for the future */
  Future: 'FUTURE'
});
/** States that a sprint can be in */

export const RoadmapTimelineModeValues = Object.freeze({
  /** Weeks */
  Weeks: 'WEEKS',

  /** Months */
  Months: 'MONTHS',

  /** Quarters */
  Quarters: 'QUARTERS'
});
/** Defines the available timeline modes */

export const RoadmapVersionStatusValues = Object.freeze({
  /** version has been released */
  Released: 'RELEASED',

  /** version has not been released */
  Unreleased: 'UNRELEASED',

  /** version has been archived */
  Archived: 'ARCHIVED'
});
/** Avaliable version statuses */

export const ScopeValues = Object.freeze({
  /** identity */
  ManageOrg: 'MANAGE_ORG',
  AuthConfluenceUser: 'AUTH_CONFLUENCE_USER',
  ManageDirectory: 'MANAGE_DIRECTORY',
  ReadMe: 'READ_ME',
  ViewUserprofile: 'VIEW_USERPROFILE',
  IdentityAtlassianExternal: 'IDENTITY_ATLASSIAN_EXTERNAL',

  /** confluence */
  ConfluenceAtlassianExternal: 'CONFLUENCE_ATLASSIAN_EXTERNAL',
  ReadConfluenceContentAll: 'READ_CONFLUENCE_CONTENT_ALL',
  ReadConfluenceContentSummary: 'READ_CONFLUENCE_CONTENT_SUMMARY',
  WriteConfluenceContent: 'WRITE_CONFLUENCE_CONTENT',
  ReadConfluenceSpaceSummary: 'READ_CONFLUENCE_SPACE_SUMMARY',
  WriteConfluenceSpace: 'WRITE_CONFLUENCE_SPACE',
  WriteConfluenceFile: 'WRITE_CONFLUENCE_FILE',
  ReadConfluenceProps: 'READ_CONFLUENCE_PROPS',
  WriteConfluenceProps: 'WRITE_CONFLUENCE_PROPS',
  SearchConfluence: 'SEARCH_CONFLUENCE_',
  ManageConfluenceConfiguration: 'MANAGE_CONFLUENCE_CONFIGURATION',
  ReadConfluenceGroups: 'READ_CONFLUENCE_GROUPS',
  WriteConfluenceGroups: 'WRITE_CONFLUENCE_GROUPS',
  ReadConfluenceUser: 'READ_CONFLUENCE_USER',
  ReadConfluenceContentPermission: 'READ_CONFLUENCE_CONTENT_PERMISSION',

  /** ecosystem */
  ManageApp: 'MANAGE_APP',
  StorageApp: 'STORAGE_APP',

  /** jira */
  ReadJiraUser: 'READ_JIRA_USER',
  ReadJiraWork: 'READ_JIRA_WORK',
  WriteJiraWork: 'WRITE_JIRA_WORK',
  ManageJiraProject: 'MANAGE_JIRA_PROJECT',
  ManageJiraConfiguration: 'MANAGE_JIRA_CONFIGURATION',
  JiraAtlassianExternal: 'JIRA_ATLASSIAN_EXTERNAL',
  ManageJiraDataProvider: 'MANAGE_JIRA_DATA_PROVIDER',

  /** jira-servicedesk */
  ReadServicedeskRequest: 'READ_SERVICEDESK_REQUEST',
  WriteServicedeskRequest: 'WRITE_SERVICEDESK_REQUEST',
  ManageServicedeskCustomer: 'MANAGE_SERVICEDESK_CUSTOMER',

  /** notification-log */
  ReadNotifications: 'READ_NOTIFICATIONS',
  WriteNotifications: 'WRITE_NOTIFICATIONS',

  /** outbound-auth */
  AdminContainer: 'ADMIN_CONTAINER',
  ReadContainer: 'READ_CONTAINER',
  WriteContainer: 'WRITE_CONTAINER',

  /** platform */
  MigrateConfluence: 'MIGRATE_CONFLUENCE'
});
export const SoftwareCardsDestinationEnumValues = Object.freeze({
  NewSprint: 'NEW_SPRINT',
  Backlog: 'BACKLOG',
  ExistingSprint: 'EXISTING_SPRINT'
});
export const SortDirectionValues = Object.freeze({
  /** Sort in ascending order */
  Asc: 'ASC',

  /** Sort in descending order */
  Desc: 'DESC'
});
/** The sort direction of the collection */

export const SprintReportsEstimationStatisticTypeValues = Object.freeze({
  StoryPoints: 'STORY_POINTS',
  IssueCount: 'ISSUE_COUNT',
  OriginalEstimate: 'ORIGINAL_ESTIMATE'
});
export const SprintStateValues = Object.freeze({
  Active: 'ACTIVE',
  Future: 'FUTURE',
  Closed: 'CLOSED'
});
export const SwimlaneStrategyValues = Object.freeze({
  None: 'NONE',
  Assignee: 'ASSIGNEE',
  Issueparent: 'ISSUEPARENT',
  Issuechildren: 'ISSUECHILDREN'
});
/** How to group cards on the board into swimlanes */